export const getCache = key => {
  if (window.localStorage) {
    return window.localStorage.getItem(key);
  }
  return null;
};

export const setCache = (key, value) => {
  if (window.localStorage) {
    window.localStorage.setItem(key, value);
  }
};
